import React from 'react';
import {  IconDots, IconEdit,  IconTrash } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../../components/mantine/menu";
import { ActionIcon, rem } from '@mantine/core';

const ActionMenu = (props:any) => { 
   const { item, open,  SetSelectedRows ,openDeletePopUp ,openEditPopUp }=props
   return(
    <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
        <MantineMenuTarget>
            <ActionIcon variant="subtle" color="gray">
                <IconDots style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </ActionIcon>
        </MantineMenuTarget>
        <MantineMenuDropdown>
            <MantineMenuItem
                leftSection={<IconEdit style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                onClick={() => { openEditPopUp (); SetSelectedRows(item); }}
            >
                Edit
            </MantineMenuItem>
             <MantineMenuItem
                leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                onClick={() => { openDeletePopUp(); SetSelectedRows(item); }}
            >
               Delete
            </MantineMenuItem>
        </MantineMenuDropdown>
    </MantineMenu>
    );
};

export default ActionMenu;
